<div
  *ngIf="cardData"
  class="delete-card">
  <h2 class="headline">{{'SAVED_CARD_PAGE.MODAL_DELETE.TITLE' | translate}}</h2>
  <p
    class="description">
    {{'SAVED_CARD_PAGE.MODAL_DELETE.DESCRIPTION' | translate}} *{{cardData.card_num}} ?
  </p>
  <div class="btn-block">
    <button
      (click)="deleteCard()"
      class="btn btn-danger">
      {{'SAVED_CARD_PAGE.MODAL_DELETE.DELETE' | translate}}
    </button>
    <button
      (click)="closeModal()"
      class="btn btn-light">
      {{'SAVED_CARD_PAGE.MODAL_DELETE.CANCEL' | translate}}
    </button>
  </div>
</div>
